import SideModule from './SideModule';

export default SideModule;
